import React from 'react';

import {
  GenderFilterValue,
  GenderValue,
  GenderFilterCount,
} from 'ha/types/SearchFilters';
import { useIntl } from 'ha/i18n';

import CommonCheckboxFilter from './CommonCheckboxFilter';
import CommonCheckboxTitleWithCount from './CommonCheckboxTitleWithCount';

interface Props {
  value: GenderFilterValue;
  onChange: (value: GenderFilterValue) => void;
  count?: GenderFilterCount;
}

const GenderFilter: React.FC<Props> = ({ value, onChange, count }) => {
  const { T } = useIntl();

  return (
    <CommonCheckboxFilter
      options={[
        {
          value: GenderValue.BOYS,
          title: (
            <CommonCheckboxTitleWithCount
              title={T('Male')}
              count={count?.male}
            />
          ),
          testLocator: 'Filter Male',
        },
        {
          value: GenderValue.GIRLS,
          title: (
            <CommonCheckboxTitleWithCount
              title={T('Female')}
              count={count?.female}
            />
          ),
          testLocator: 'Filter Female',
        },
      ]}
      value={value}
      onChange={onChange}
    />
  );
};

export default GenderFilter;
